<div class="page-container">
  <!-- HEADER -->
  <header class="page-header">
    <span class="eyebrow">Guidelines & Policy</span>
    <h1 class="page-title">Rental Responsibility</h1>
    <p class="page-subtitle">
      Clear allocation of operational obligations, site requirements, and liability boundaries for Customers, Vendors, and Aluguloo.
    </p>
  </header>

  <!-- 3 ROLE CARDS -->
  <section class="roles-grid">
    <div class="role-card">
      <div class="role-header">
        <span class="role-pill">Hiring Party</span>
        <h2>Customer</h2>
      </div>
      <ul class="role-points">
        <li><strong>Site Preparation:</strong> Ensure safe site access, ground firmness, and gate permits prior to machinery arrival.</li>
        <li><strong>Authorized Use:</strong> Operate machinery strictly within manufacturer rated load and safety specifications.</li>
        <li><strong>Timesheet Verification:</strong> Review and sign daily working logs, standby hours, and breakdown records promptly.</li>
        <li><strong>Payment Settlement:</strong> Comply with agreed payment milestones and accepted LPO commercial terms.</li>
        <li><strong>Site Security:</strong> Provide reasonable protection for equipment while stationed on site during non-operational hours.</li>
      </ul>
    </div>

    <div class="role-card">
      <div class="role-header">
        <span class="role-pill">Equipment Owner</span>
        <h2>Vendor</h2>
      </div>
      <ul class="role-points">
        <li><strong>Fitness & Safety:</strong> Mobilize fully operational, serviced, and mechanically inspected machinery.</li>
        <li><strong>Legal Documentation:</strong> Maintain current UAE vehicle registration (Mulkiya) and statutory inspection approvals.</li>
        <li><strong>Commercial Insurance:</strong> Ensure active comprehensive insurance covering machinery breakdown and third-party liabilities.</li>
        <li><strong>Certified Operators:</strong> For "with operator" hires, provide licensed, tested, and legally sponsored operators.</li>
        <li><strong>Breakdown Support:</strong> Promptly repair mechanical failures or deploy equivalent replacement machinery.</li>
      </ul>
    </div>

    <div class="role-card">
      <div class="role-header">
        <span class="role-pill">Digital Platform</span>
        <h2>Aluguloo</h2>
      </div>
      <ul class="role-points">
        <li><strong>Intermediary Platform:</strong> Connect verified equipment owners with prospective hirers across the UAE.</li>
        <li><strong>Workflow Tooling:</strong> Provide standardized digital tools for generating LPOs, timesheets, and invoices.</li>
        <li><strong>No Equipment Ownership:</strong> Aluguloo does not own, operate, or directly inspect physical machinery.</li>
        <li><strong>Direct Payments:</strong> All financial payments and credit agreements remain directly between Customer and Vendor.</li>
        <li><strong>Audit Records:</strong> Maintain tamper-evident timestamp logs of digital orders and communications for dispute resolution.</li>
      </ul>
    </div>
  </section>

  <!-- RESPONSIBILITY TABLE -->
  <section class="table-section">
    <h2 class="section-title">Operational Responsibility Matrix</h2>
    <div class="table-wrapper">
      <table class="matrix-table">
        <thead>
          <tr>
            <th>Obligation / Activity</th>
            <th>Responsible Party</th>
            <th>Governing Standard</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Equipment Specifications & Rate Accuracy</td>
            <td><span class="badge badge-vendor">Vendor</span></td>
            <td>Listing Terms</td>
          </tr>
          <tr>
            <td>Site Accessibility & Ground Safety</td>
            <td><span class="badge badge-customer">Customer</span></td>
            <td>Site Readiness Policy</td>
          </tr>
          <tr>
            <td>Machinery Mobilization & Delivery</td>
            <td><span class="badge badge-vendor">Vendor</span></td>
            <td>Accepted LPO</td>
          </tr>
          <tr>
            <td>Operator Licensing & Safety Badges</td>
            <td><span class="badge badge-vendor">Vendor</span></td>
            <td>UAE Labor & Traffic Laws</td>
          </tr>
          <tr>
            <td>Daily Timesheet Verification</td>
            <td><span class="badge badge-customer">Customer</span></td>
            <td>Platform Timesheet System</td>
          </tr>
          <tr>
            <td>Rental Invoicing & Direct Settlement</td>
            <td><span class="badge badge-customer">Customer</span></td>
            <td>Agreed Payment Terms</td>
          </tr>
          <tr>
            <td>Traffic Fines & Site Violations</td>
            <td><span class="badge badge-neutral">Operating Party</span></td>
            <td>Applicable UAE Regulations</td>
          </tr>
          <tr>
            <td>Platform Infrastructure & Digital Tools</td>
            <td><span class="badge badge-platform">Aluguloo</span></td>
            <td>Platform Terms</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- PROTOCOL BOX -->
  <section class="notice-box">
    <div class="notice-content">
      <h3>Breakdown & Incident Reporting</h3>
      <p>
        In the event of an on-site mechanical breakdown, work should halt immediately to avoid further damage. 
        Log breakdown hours directly in the Aluguloo digital timesheet (breakdown hours are excluded from hire billing) 
        and coordinate resolution with the equipment vendor through your active booking workspace.
      </p>
    </div>
  </section>
</div>
